import { useState } from "react";
import { Check, Copy } from "lucide-react";
import { IconButton } from "@platform/ui";
import { useT } from "../i18n";

export function CopyButton({ value, label }: { value: string; label?: string }) {
  const { t } = useT();
  const [done, setDone] = useState(false);
  return (
    <IconButton
      label={done ? t("common.copied") : (label ?? t("common.copy"))}
      onClick={() => {
        void navigator.clipboard?.writeText(value).then(() => {
          setDone(true);
          setTimeout(() => setDone(false), 1500);
        });
      }}
    >
      {done ? <Check className="size-4 text-success" aria-hidden /> : <Copy className="size-4" aria-hidden />}
    </IconButton>
  );
}
